// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    ActivityChildrenActualHours_Text: 'Log temporali per tutte le sub-attività:',
    ActivityChildrenEstimatedHours_Text: 'Ore previste per tutte le sub-attività:',
    ActivityOwnBudget_Text: 'Budget per l\'attività:',
    ActivityOwnEstimatedHours_Text: 'Ore previste per l\'attività:',
    ActivitySubactivitiesBudget_Text: 'Budget per tutte le sub-attività:',
    ActualCompletion_Text: 'Completamento effettivo',
    ActualHours_Total_Text: 'Ore effettivamente spese, totale:',
    AddTimeEntry_Text: 'Aggiungere la voce tempo',
    AddUser_Text: 'Invitare un Utente',
    BudgetedCost_Text: 'Costo previsto:',
    BudgetTotal_Text: 'Budget, totale:',
    Cancel: 'Annullare',
    Close: 'Chiudere',
    Cost_Text: 'Costo:',
    CustomerLabel: 'Cliente',
    Duration_Text: 'Durata',
    EditProjectMembers_Title: 'Membri del progetto',
    EditTaskAssignees_Title: 'Destinatari',
    End_Text: 'Completamento',
    EndDate_Text: 'Data di completamento',
    EstimatedHours_Text: 'Ore previste:',
    EstimatedHours_Total_Text: 'Ore previste, totale:',
    HoursLeftLabel: 'Ore rimaste:',
    InternalCost_Text: 'Costi interni:',
    NonProjectMembers_Text: 'Membri esterni al Progetto',
    OwnActualHours_Text: 'Registri di tempo per l\'attività:',
    PlannedExpenses_Text: 'Spese pianificate:',
    Progress: 'Progresso',
    ProgressCalculatedBySubActivities: 'Basato sul progresso delle sub-attività',
    ProjectChildrenActualHours_Text: 'Registri di tempo per le attività:',
    ProjectChildrenEstimatedHours_Text: 'Ore previste per tutte le attività:',
    ProjectMembers_Text: 'Membri del progetto',
    ProjectOwnBudget_Text: 'Budget per il progetto:',
    ProjectOwnEstimatedHours_Text: 'Ore previste per il progetto:',
    ProjectSubactivitiesBudget_Text: 'Budget per tutte le attività:',
    Start_Text: 'Iniziare',
    StartDate_Text: 'Data di inizio',
    Tooltip_ItemCompleted: 'Impossibile modificare la data, poiché è collegata a un\'attività/un progetto chiuso.',
    Untitled: 'Senza titolo',
    Validation_ActComplDateRange: 'La data di completamento effettiva non rientra nell\'intervallo previsto.',
    Validation_DateMandatory: 'La data è un campo obbligatorio',
    Validation_EndDateRange: 'La data di completamento non rientra nell\'intervallo previsto.',
    Validation_FieldMandatory: 'Campo obbligatorio.',
    Validation_FromDateRange: 'La data di inizio non rientra nell\\\'intervallo previsto.',
    Validation_Interger: 'Il valore deve essere un numero intero.',
    Validation_InvalidDate: 'La data deve essere in formato \'{0}\'.',
    Validation_NumberRange: 'Il valore deve essere compreso tra {0} and {1}',
    Validation_Range: 'Il valore non rientra nell\'intervallo previsto.',
    Validation_StartDateRange: 'La data di inizio non rientra nell\'intervallo previsto.',
    Validation_ToDateRange: 'La data di completamento non rientra nell\\\'intervallo previsto.',
    Validation_WeekendOrVacation: 'Il valore non deve ricadere in un fine settimana o in un giorno festivo.',
    Warning_UnassigneFromAllTasksInProject: 'Le assegnazioni dei membri rimossi saranno annullate in tutte le attività del progetto.',
};
